export default "__VITE_ASSET__DewcJX$X__"